// removed by extract-text-webpack-plugin
module.exports = {"dialog":"DialogComponent__dialog___2MOjZ","message":"DialogComponent__message___1M5VE","confirmContainer":"DialogComponent__confirmContainer___1jlUJ","confirm":"DialogComponent__confirm___2bILX","error":"DialogComponent__error___JPKbv"};


//////////////////
// WEBPACK FOOTER
// ./src/game/menus/DialogComponent.scss
// module id = 156
// module chunks = 0